import React from 'react';
import styles from './Word.module.css';
import check from '../assets/check.svg';

const Word = (props) => {

    let word = (
        <div className={styles.word} onClick={() => { props.guess(props.id) }}>
            {props.word.text}
        </div>
    );
    if (props.word.guessed) {
        word = (
            <div className={styles.word} onClick={() => { props.guess(props.id) }}>
                {props.word.text}
                <img src={check} alt='check' />
            </div>
        );
    }
    return word;
}

export default Word;